var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1906 16.8754L14.6407 13.3255C15.6 12.0873 16.1712 10.5382 16.1712 8.85623C16.1712 4.82009 12.8897 1.53857 8.85357 1.53857C4.81744 1.53857 1.53857 4.82009 1.53857 8.85357C1.53857 12.8871 4.82009 16.1686 8.85357 16.1686C10.5355 16.1686 12.0873 15.5973 13.3228 14.6381L16.8727 18.188C17.0534 18.3687 17.2925 18.4617 17.5317 18.4617C17.7708 18.4617 18.0073 18.3713 18.1906 18.188C18.5547 17.8239 18.5547 17.2367 18.1906 16.8727V16.8754ZM3.39855 8.85357C3.39855 5.84574 5.84574 3.39855 8.85357 3.39855C11.8614 3.39855 14.3086 5.84574 14.3086 8.85357C14.3086 11.8614 11.8614 14.3086 8.85357 14.3086C5.84574 14.3086 3.39855 11.8641 3.39855 8.85357Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon_search.c2fe8b2655a5cec682369a1200dfd262.svg";
export { ForwardRef as ReactComponent };